export const MAP_LANDMARKS_GROUPS_DELETE_OPEN_MODAL = "MAP_LANDMARKS_GROUPS_DELETE_OPEN_MODAL";

export const MAP_LANDMARKS_DELETE_LANDMARK_GROUPS = "MAP_LANDMARKS_DELETE_LANDMARK_GROUPS";
export const MAP_LANDMARKS_DELETE_LANDMARK_GROUPS_RESPONSE = "MAP_LANDMARKS_DELETE_LANDMARK_GROUPS_RESPONSE";